import script from "./remark-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./remark-cell.vue?vue&type=script&setup=true&lang=js"

import "./remark-cell.vue?vue&type=style&index=0&id=bb470510&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb470510"]])

export default __exports__